export default __webpack_public_path__ + "static/media/Q18.d55cf18c.jpg";